import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin, DatePicker } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useFootfall from '../useFootfall';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import moment from 'moment';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    title,
    searchParams,
    format,
    loading,
    summary,
    handleDownloadExcel,
    handleDownloadPdf,
    loadingPdf,
    errors,
  } = useFootfall();
  const { t } = useTranslation();

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={t('Footfall').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              big
              icon={<PlusOutlined />}
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <AlertMessage errors={errors} searchParams={searchParams} />
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <br />
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row>
              <Col xs={24} xxl={12}>
                <Table
                  columns={columns}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                  summary={summary}
                />
              </Col>
              <Col xs={24} xxl={12}>
                <LineChart
                  formatTooltip={Helpers.numberWithCommas}
                  data={data.lineChartData}
                  tableData={data.tableData}
                  colors={['#61cdbb', '#f47560']}
                />
                <BarChangeChart
                  data={data}
                  format={format}
                  keys={['Footfall LY', 'Footfall YTD']}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
